import {
	createStyles,
	TableCell,
	TableSortLabel,
	Theme,
	Tooltip,
	Typography,
	WithStyles,
	withStyles,
} from '@material-ui/core'
import { grey } from '@material-ui/core/colors'
import * as React from 'react'
import { Sort } from '../../../services/sortingService'

interface HeaderCellProps extends WithStyles<typeof styles> {
	label: string
	prop: string
	sortBy: string
	sortDirection: Sort
	handleSortClick: (sortDirection: Sort, sortBy: string) => (event: React.MouseEvent<HTMLElement>) => void
	cellProps?: { [key: string]: any }
	typographyProps?: { [key: string]: any }
}

const HeaderCell: React.FC<HeaderCellProps> = (props: HeaderCellProps) => {
	const { cellProps, classes, label, sortBy, sortDirection, handleSortClick, prop, typographyProps } = props

	return (
		<TableCell
			scope="row"
			component="div"
			variant="head"
			className={classes.colHeader}
			data-auto={`table-header-row-item-${prop}`}
			{...cellProps}
		>
			<Tooltip title="Sort" placement="right" enterDelay={300}>
				<TableSortLabel
					active={sortBy === prop}
					direction={sortDirection}
					onClick={handleSortClick(sortDirection, prop)}
					style={{ color: grey[50] }}
				>
					<Typography
						variant="button"
						className={classes.typographyHeader}
						data-auto={`header-${prop}`}
						{...typographyProps}
					>
						{label}
					</Typography>
				</TableSortLabel>
			</Tooltip>
		</TableCell>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		colHeader: {
			padding: `${theme.spacing.unit / 2}px ${theme.spacing.unit * 3}px `,
			textOverflow: 'ellipsis',
		},
		typographyHeader: {
			color: grey[50],
		},
	})

export default withStyles(styles)(HeaderCell)
